import consumer from "./consumer";

(function () {
  const BOTTOM_THRESHOLD = 100;

  function escapeHtml(text) {
    return $("<div>").text(text).html();
  }

  function simpleMarkdown(text) {
    var escaped = escapeHtml(text);
    escaped = escaped.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    escaped = escaped.replace(/\*(.+?)\*/g, "<em>$1</em>");
    escaped = escaped.replace(/`(.+?)`/g, "<code>$1</code>");
    escaped = escaped.replace(/\[([^\]]+)\]\((\/[^)]*)\)/g, '<a href="$2">$1</a>');
    escaped = escaped.replace(/\n/g, "<br>");
    return escaped;
  }

  function isNearBottom() {
    var $container = $("#chat-messages");
    var distanceFromBottom =
      $container[0].scrollHeight -
      $container.scrollTop() -
      $container.outerHeight();
    return distanceFromBottom < BOTTOM_THRESHOLD;
  }

  function scrollToBottom() {
    var $container = $("#chat-messages");
    $container.scrollTop($container[0].scrollHeight);
  }

  function showLoadingBubble() {
    $("#chat-loading").removeClass("d-none");
    scrollToBottom();
  }

  function hideLoadingBubble() {
    $("#chat-loading").addClass("d-none");
  }

  function appendUserMessage(text) {
    $("#chat-suggestions").remove();
    var html =
      '<div class="d-flex mb-3 justify-content-end">' +
      '<div class="chat-bubble chat-bubble-user">' +
      '<div class="chat-bubble-content">' +
      escapeHtml(text) +
      "</div>" +
      "</div>" +
      "</div>";
    $("#chat-loading").before(html);
    scrollToBottom();
  }

  function appendAssistantMessage(content, citations) {
    var citationsHtml = "";
    if (citations && citations.length > 0) {
      citationsHtml += '<div class="chat-citations d-none mt-2"><small class="text-muted">Sources:</small>';
      citations.forEach(function (c) {
        citationsHtml +=
          '<small class="d-block text-muted">• ' + escapeHtml(c) + "</small>";
      });
      citationsHtml += "</div>";
    }

    var html =
      '<div class="d-flex mb-3 justify-content-start">' +
      '<div class="chat-bubble chat-bubble-assistant">' +
      '<div class="chat-bubble-content">' +
      simpleMarkdown(content) +
      "</div>" +
      citationsHtml +
      "</div>" +
      "</div>";
    $("#chat-loading").before(html);
    scrollToBottom();
  }

  function setFormEnabled(enabled) {
    $("#chat-input, #chat-submit").prop("disabled", !enabled);
    if (enabled) {
      $("#chat-input").focus();
    }
  }

  var chatSubscription = null;

  function init() {
    if (!gon || !gon.conversation_id) return;
    if ($("#chat-messages").length === 0) return;

    scrollToBottom();

    if (chatSubscription) {
      chatSubscription.unsubscribe();
    }

    chatSubscription = consumer.subscriptions.create(
      {
        channel: "AiSupport::ChatChannel",
        conversation_id: gon.conversation_id,
      },
      {
        received: function (data) {
          if (data.type === "start") {
            showLoadingBubble();
          } else if (data.type === "done") {
            hideLoadingBubble();
            appendAssistantMessage(data.content, data.citations || []);
            setFormEnabled(true);
          } else if (data.type === "error") {
            hideLoadingBubble();
            appendAssistantMessage(
              data.content ||
                "Sorry, something went wrong. Please try again.",
              []
            );
            setFormEnabled(true);
          }
        },
      }
    );

    $("#chat-form").off("submit.ai_support").on("submit.ai_support", function (e) {
      e.preventDefault();
      var query = $("#chat-input").val().trim();
      if (!query) return;

      appendUserMessage(query);
      setFormEnabled(false);
      $("#chat-input").val("");

      $.ajax({
        url: gon.message_path,
        method: "POST",
        data: { query: query },
        headers: { "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") },
        error: function (xhr) {
          hideLoadingBubble();
          var msg =
            xhr.status === 429
              ? "You're sending messages too fast. Please wait a moment."
              : "Sorry, something went wrong. Please try again.";
          appendAssistantMessage(msg, []);
          setFormEnabled(true);
        },
      });
    });

    $(document).off("click.ai_support").on("click.ai_support", ".chat-suggestion", function () {
      var text = $(this).data("text");
      $("#chat-input").val(text);
      $("#chat-form").trigger("submit");
    });
  }

  function teardown() {
    if (chatSubscription) {
      chatSubscription.unsubscribe();
      chatSubscription = null;
    }
    $("#chat-form").off("submit.ai_support");
    $(document).off("click.ai_support");
  }

  $(document).on("turbolinks:load ai-support:conversation-changed", init);
  $(document).on("turbolinks:before-visit", teardown);
})();
